import $ from "jquery";

interface TableRecord {
  rank: number;
  fields: TableField[];
}

interface TableField {
  pairing_item_id: number;
  pairing_item_name: string;
}

interface TableData {
  titles: string[];
  selected_item_ids: number[];
  records: TableRecord[];
}

class CombinationRankingTable {
  private tableRootElement: JQuery;
  private titles: string[];
  private selectedItemIds: number[];
  private records: TableRecord[];

  constructor(tableRootElement: JQuery, table: TableData) {
    this.tableRootElement = tableRootElement;
    this.titles = table.titles;
    this.selectedItemIds = table.selected_item_ids;
    this.records = table.records;
  }

  toHtml(): string {
    return `
      <table>
        ${this.tableHeader()}
        ${this.tableRows()}
      </table>
    `;
  }

  private tableHeader(): string {
    const headers = this.titles
      .map((title) => {
        return `<th>${title}</th>`;
      })
      .join("");

    return `
      <tr>
        <th class="rank_header">位</th>
        ${headers}
      </tr>
    `;
  }

  private tableRows(): string {
    return this.records
      .map((record) => {
        const rank = record.rank;
        const fields = record.fields;
        const trClass = rank % 2 === 0 ? "even" : "odd";
        const rankingCells = this.rankingCells(fields).join("");

        return `
        <tr class="${trClass}">
          ${this.rankNumberCell(rank)}
          ${rankingCells}
        </tr>
      `;
      })
      .join("");
  }

  private rankNumberCell(rank: number): string {
    const rankCell =
      parseInt(String(rank), 10) <= 3
        ? `<img src="${this.rankingImageFor(rank)}" />`
        : String(rank);

    return `<td class="rank_cell">${rankCell}</td>`;
  }

  private rankingCells(record: TableField[]): string[] {
    return record.map((field) => {
      if (field) {
        const tdClasses = [`ranking_cell_${field.pairing_item_id}`];
        const index = this.selectedItemIds.indexOf(field.pairing_item_id);
        if (index >= 0) {
          tdClasses.push(`selected_cell_${index + 1}`);
        }

        return `
          <td class="${tdClasses.join(" ")}">
            <a href="${this.itemUrl()}" class="keyword_link" data-item-id="${field.pairing_item_id}">
              ${field.pairing_item_name}
            </a>
          </td>
        `;
      } else {
        return "<td />";
      }
    });
  }

  private itemUrl(): string {
    return this.tableRootElement.data("itemUrl");
  }

  private rankingImagePaths(): string[] {
    return this.tableRootElement.data("rankingImagePaths");
  }

  private rankingImageFor(rank: number): string {
    return this.rankingImagePaths()[rank - 1];
  }
}

class CombinationRankingTableView {
  private tableRootElement: JQuery;

  constructor(tableRootElement: JQuery) {
    this.tableRootElement = tableRootElement;
  }

  initialize(): void {
    this.showIndicator();
  }

  renderCombinationRankingTable(table: TableData): void {
    this.hideIndicator();
    const combinationRankingTable = new CombinationRankingTable(
      this.tableRootElement,
      table,
    );
    this.tableRootElement.append(combinationRankingTable.toHtml());
    this.setSelectedItemIds(table.selected_item_ids);
  }

  private itemSelectionElement(): JQuery {
    return $("#itemSelection");
  }

  private setSelectedItemIds(selectedItemIds: number[]): void {
    const currentSelectingIds = this.selectingItemIds();
    const newItemIds = selectedItemIds.filter(
      (id) => !currentSelectingIds.includes(id),
    );

    newItemIds.forEach((itemId) => {
      const hiddenElement = `
        <input type="hidden" name="selection[]" value="${itemId}" class="selectingItemId" />
      `;
      this.itemSelectionElement().append(hiddenElement);
    });
  }

  private selectingItemIds(): number[] {
    return $(".selectingItemId")
      .map((index, element) => {
        return parseInt($(element).val() as string, 10);
      })
      .get();
  }

  showIndicator(): void {
    const indicatorElement =
      '<div class="indicator gr" style="height: 1000px;" />';
    this.tableRootElement.append(indicatorElement);
  }

  hideIndicator(): void {
    this.tableRootElement.empty();
  }

  clearTable(): void {
    this.tableRootElement.empty();
  }

  updateCsvUrl(url: string): void {
    const elem = $(".combination_ranking_box").find(".csv_button");
    elem.removeClass("disabled enable_later");
    let a = elem.find("a");

    if (a.length > 0) {
      a.attr("href", url);
    } else {
      // first time
      const img = elem.html();
      elem.html("<a></a>");
      a = elem.children();
      a.append(img);
      a.attr("href", url);
    }
  }
}

export { CombinationRankingTableView, CombinationRankingTable };
